module.exports = __webpack_public_path__ + "static/media/Protocolos_de_Chequeo.01f970d5.docx";